class WebRoot {

    /**
     * @param {string} root
     */
    constructor(root) {
        this.root = document.querySelector(root);
        if (!this.root) console.error("Root element not found:'" + root + "'");
    }

    /**
     * @param {string} selector
     * @param {HTMLElement} el
     * @returns {NodeList}
     */
    find(selector, el) {
        let root = el || this.root;
        return root.querySelectorAll(selector);
    }

    /**
     * @param {string} selector
     * @param {HTMLElement} el
     * @returns {Array}
     */
    findVisible(selector, el) {
        let elements = Array.from(this.find(selector, el));
        elements = elements.filter((el) => {
            return el.offsetHeight > 0 || el.offsetWidth > 0;
        });
        return elements;
    }

    /**
     * @param {HTMLElement} elem
     * @param {string} type
     * @param {Function} listener
     */
    on(elem, type, listener) {
        elem.addEventListener(type, (e) => {
            listener.call(this, e, elem);
        });
    }

}

class MapAnalysis extends WebRoot {

    constructor(root) {
        super(root);
        this.root.mapAnalysis = this;
        this.selectedDay = null;
        this.selectedHour = null;
        this.rootLevel = Number.parseInt(this.root.dataset.rootLevel);
        this.openedLevel = 0;
        this.spanMax = this.root.querySelector('[span="max"]');
        this._initEvents();
    }

    handleShowCell(e, td) {
        e.preventDefault();
        let day = td.dataset.d;
        let hour = td.dataset.h;

        if (this.selectedDay === day && this.selectedHour === hour) {
            this.selectedDay = null;
            this.selectedHour = null;
        } else {
            this.selectedDay = day;
            this.selectedHour = hour;
        }

        this._dayChanged();
        this._hourChanged();
    }

    handleShowDay(e, td) {
        e.preventDefault();
        let day = td.dataset.day;
        this.selectedDay = (this.selectedDay === day) ? null : day;
        this._dayChanged();
        this._hourChanged();
    }

    handleShowHour(e, td) {
        e.preventDefault();
        let hour = td.dataset.hour;
        this.selectedHour = (this.selectedHour === hour) ? null : hour;
        this._hourChanged();
    }

    handleOpenLevel(e, tr) {
        e.preventDefault();
        let childrenCount = Number.parseInt(tr.dataset.children);
        if (childrenCount < 1) return;

        let level = Number.parseInt(tr.dataset.level);
        let id = Number.parseInt(tr.dataset.id);

        let rows = tr.parentElement.querySelectorAll(".hm-row");
        if (this.openedLevel < level) rows = [];
        for (let row of rows) {
            let rowLevel = Number.parseInt(row.dataset.level);
            if (rowLevel !== level && rowLevel > this.rootLevel + 1) {
                row.style.display = "none";
            }
        }

        this.openedLevel = level;

        let children = tr.parentElement.querySelectorAll('[data-parent="' + id + '"]');
        for (let child of children) {
            child.style.display = "";
        }

        this._hourChanged();
    }

    _dayChanged() {
        let detail = this.findVisible(".detail[data-d]")[0];
        if (detail) detail.style.display = "none";
        let active = this.root.querySelector(".selected[data-day]");
        if (active) active.classList.remove("selected");

        if (!this.selectedDay) return;

        detail = this.root.querySelector('.detail[data-d="' + this.selectedDay + '"]');
        if (detail) detail.style.display = "";
        active = this.root.querySelector('[data-day="' + this.selectedDay + '"]');
        if (active) active.classList.add("selected");

        this.openedLevel = this.rootLevel;
        let rows = detail.querySelectorAll(".hm-row");
        for (let row of rows) {
            let rowLevel = Number.parseInt(row.dataset.level);
            if (rowLevel > this.rootLevel + 1) {
                row.style.display = "none";
            }
        }
    }

    _hourChanged() {
        if (this.selectedHour) this.root.classList.add("selected");
        else this.root.classList.remove("selected");
        this.spanMax.style.flex = this.selectedHour ? 29 : 26;

        let rows = this.findVisible(".hm-row");
        rows.forEach((row) => {
            if (row.dataset.d) return true;

            let active = row.querySelectorAll(".active");
            active.forEach((td) => {
                td.classList.remove("active");
            });
        });

        if (!this.selectedHour) return;

        rows.forEach((row) => {
            if (row.dataset.d) return true;

            let active = row.querySelectorAll('[data-h="' + this.selectedHour + '"]');
            active.forEach((td) => {
                td.classList.add("active");
            });
        });
    }

    _initEvents() {
        this.find('[on-click="showCell"]').forEach((elem) => {
            this.on(elem, "click", this.handleShowCell);
        });
        this.find('[on-click="showDay"]').forEach((elem) => {
            this.on(elem, "click", this.handleShowDay);
        });
        this.find('[on-click="showHour"]').forEach((elem) => {
            this.on(elem, "click", this.handleShowHour);
        });
        this.find('[on-click="openLevel"]').forEach((elem) => {
            this.on(elem, "click", this.handleOpenLevel);
        });
    }

}
